import React, { useEffect, useCallback } from "react"
import styles from "./Testimonials.module.scss"

import andrewPic from "../../assets/testimonials/andrew.jpeg"
import elizPic from "../../assets/testimonials/elizabeth.jpeg"
import gregPic from "../../assets/testimonials/greg.jpeg"
import jonPic from "../../assets/testimonials/jon.jpeg"

import { useCarousel } from "../../hooks/useCarousel"
import quoteIcon from "../../assets/icons/quote.svg"

enum COLOURS {
  YELLOW = "#EFBE47",
  PURPLE = "#6670A0",
  DARK = "#31364d",
  GREEN = "#9DD091",
  EXTRADARK = "#282c3e",
  OFFWHITE = "#fbfbfb",
}

const INTERVAL = 70000
const TESTIMONIALS_DATA = [
  {
    colour: COLOURS.GREEN,
    quote: (
      <p>
        <strong>Great questions on the cards</strong> to kick the brain into thinking about a
        situation. Slick interface to go through a deck, either one by one or in a batch.
      </p>
    ),
    author: "Andrew Reeves-Hall",
    role: "Agile Coach",
    pic: andrewPic,
  },
  {
    colour: COLOURS.YELLOW,
    quote: (
      <p>
        I LOVE these cards! Especially for introverts, sometimes they are unable to express
        themselves and this will help.
      </p>
    ),
    author: "Elizabeth Marinakis",
    role: "Agile Coach",
    pic: elizPic,
  },
  {
    colour: COLOURS.GREEN,
    quote: (
      <p>
        <strong>So much inspiration in one app!</strong> It's like having Geoff (leadership coach
        extraordinaire) in your pocket to dish out insightful questions and prompts exactly when you
        need it. Highly recommend - I've been using it daily.
      </p>
    ),
    author: "A Google User",
    role: "Product Owner",
    pic: undefined,
  },
  {
    colour: COLOURS.YELLOW,
    quote: (
      <p>
        These cards are awesome. They really help me and the teams I work with{" "}
        <strong>get better every day.</strong>
      </p>
    ),
    author: "Greg Pitcher",
    role: "Agile Coach",
    pic: gregPic,
  },
  {
    colour: COLOURS.GREEN,
    quote: (
      <p>
        <strong>Absolutely the best agile coaching app, hands down! </strong>
        All scrum master / agile coach needs and more in one place.
      </p>
    ),
    author: "A Google User",
    role: "Scrum Master",
    pic: undefined,
  },
  {
    colour: COLOURS.YELLOW,
    quote: (
      <p>
        "I own these decks in physical form and knowing that they're all in my pocket at any time is
        so reassuring. And there are MORE DECKS HERE!!"
      </p>
    ),
    author: "Jon McNestrie",
    role: "Agile Coach",
    pic: jonPic,
  },
]
const LENGTH = TESTIMONIALS_DATA.length

const Testimonials: React.FC = () => {
  const { index, offset, next, back, goTo, handlers, Carousel } = useCarousel(LENGTH)

  useEffect(() => {
    const interval = setInterval(next, INTERVAL)
    return () => clearInterval(interval)
  }, [])

  const colour = TESTIMONIALS_DATA[index].colour

  const onIndicatorPress = useCallback((i: number) => {
    goTo(i)
  }, [])

  return (
    <section className={styles.container} style={{ backgroundColor: colour }} {...handlers}>
      <div />
      <img src={quoteIcon} style={{ transform: "rotate(5deg)" }} alt="quote" />
      <img src={quoteIcon} style={{ transform: "rotate(-175deg)" }} alt="quote" />
      <Carousel index={index} offset={offset}>
        {TESTIMONIALS_DATA.map(data => (
          <TestimonialCard key={data.author} {...data} />
        ))}
      </Carousel>
      <div className={styles.indicators}>
        {TESTIMONIALS_DATA.map((data, i: number) => (
          <button
            key={data.author}
            onClick={() => onIndicatorPress(i)}
            style={{
              border: `2px solid ${i === index ? "#fff" : "transparent"}`,
              backgroundColor: i === index ? data.colour : "#fff",
              opacity: i === index ? 1 : 0.3,
            }}
          />
        ))}
      </div>
    </section>
  )
}

export default Testimonials

type TestimonialCardProps = {
  quote: React.ReactNode
  author: string
  role: string
  pic: string | undefined
  colour: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ quote, author, role, pic, colour }) => (
  <div className={styles.card} style={{ borderColor: colour }}>
    {pic && <img src={pic} alt={author} />}
    {quote}
    <span>{author}</span>
    <span style={{ color: colour }}>{role}</span>
  </div>
)
